<template>
  <div class="popup" :class="open ? 'open' : 'closed'">
    <div class="popup-content" :style="popupStyle" v-if="triggered">
      <div class="closing-bubble" @click="$emit('close')">
        <fa-icon :icon="['fa', 'times']" size="3x" />
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Popup',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    popupStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    triggered: false,
  }),
  watch: {
    open() {
      if (this.open) {
        this.triggered = true;
      }
    },
  },
};
</script>

<style lang="scss">
.popup {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  @include flex-center();

  pointer-events: none;
  background-color: none;
  transition: background-color 200ms;
  &.open {
    pointer-events: all;
    background-color: rgba(black, 0.4);
  }

  @keyframes popup {
    0% {
      transform: scale(0.7);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  @keyframes popupClose {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0.7);
      opacity: 0;
    }
  }
  &.open .popup-content {
    animation: popup 200ms forwards;
  }
  &.closed .popup-content {
    animation: popupClose 200ms forwards;
  }

  .closing-bubble {
    position: absolute;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    top: -35px;
    right: -35px;
    background: $logo-orange;
    @include flex-center();
    &:hover {
      cursor: pointer;
    }
  }

  .popup-content {
    border-radius: 5px;
    background: $basic-dark;
    overflow: visible;
    box-shadow: 0 0 20px rgba(black, 0.4);

    width: fit-content;
    height: fit-content;
    padding: 30px;
    margin: 0;
  }
}
</style>
